module.exports = __webpack_public_path__ + "media/images/countrysquared/sc-1f7ef9a67a95621167f38a1803ea6a6a.svg";